import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector   : 'eguard-nav-vertical-subheader',
    templateUrl: './nav-vertical-subheader.component.html',
    styleUrls  : ['./nav-vertical-subheader.component.scss']
})
export class EguardNavVerticalSubheaderComponent implements OnInit
{
    @HostBinding('class') classes = 'nav-subheader';
    @Input() item: any;

    constructor()
    {
    }

    ngOnInit()
    {
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/vertical/nav-subheader/nav-vertical-subheader.component.ts